
import { css, keyframes } from "@emotion/react"
import { colors } from "shared-ui"

export default function ProgressBar({ value = 0, max = 100, height = 8, doneColor = colors.main1, color= colors.main2 }) {
    const percent = Math.min(Math.max(value / max, 0), 1) * 100;
    const translationXPercent = -100 + percent

    const stripeMove = keyframes`
        0% { background-position: 0 0; }
        100% { background-position: 40px 0; }
    `

    return (
        <div
            css={css`
                width: 100%;
                height: ${height}px;
                background-color: rgba(255, 255, 255, 0.1);
                border-radius: 10px;
                overflow: hidden;
            `}
        >
            <div
                css={css`
                    width: 100%;
                    height: 100%;
                    background-color: ${value === 100 ? doneColor : color};
                    opacity: ${value === 100 ? 0.6 : 0.75};
                    background-image: ${value !== 100 ? `repeating-linear-gradient(
                    275deg,
                    rgba(0, 0, 0, 0.4),
                    transparent 10px,
                    transparent 20px
                    )` : 'none'};
                    background-size: 20px 20px;
                    animation: ${stripeMove} 0.35s linear infinite;
                    transform: translate(${translationXPercent}%, 0);
                    transform-origin: left;
                    transition: transform 0.2s ease-in-out;
                `}
            />
        </div>
    )
}